export const dashBoxShadowMapping = {
  none: '0 0 0 0 rgba(0, 0, 0, 0)',
  small: '0 2px 5px 0 rgba(60,66,87, 0.12), 0 1px 1px 0 rgba(0,0,0, 0.12);',
  medium: '0 7px 14px 0 rgba(60,66,87, 0.12), 0 3px 6px 0 rgba(0,0,0, 0.12);',
} as const

export type DashBoxShadow = keyof typeof dashBoxShadowMapping

export const dashBoxShadows = {
  NONE: dashBoxShadowMapping.none,
  SMALL: dashBoxShadowMapping.small,
  MEDIUM: dashBoxShadowMapping.medium,
} as const
